import { Version } from './project.ts';

export interface WebSocketMessage {
  type: WebSocketEventType;
  data: string;
}

export enum WebSocketEventType {
  HEARTBEAT = 'HEARTBEAT',
  END_AUTO_POSITIONING = 'END_AUTO_POSITIONING',
  END_CALCULATION = 'END_CALCULATION',
  END_RENDER_BAKING = 'END_RENDER_BAKING',
  END_REPORT_IMAGES = 'END_REPORT_IMAGES',
  END_LAMP_SIMILARITY = 'END_LAMP_SIMILARITY',
  PROGRESS = 'PROGRESS',
  NOTIFICATION = 'NOTIFICATION',
  JOB_STARTED = 'JOB_STARTED',
  CATALOGUE_SYNC_FINISHED = 'CATALOGUE_SYNC_FINISHED',
}

export interface CatalogueSyncFinishedEvent {
  status: CatalogueSyncStatus;
  commitSha: string | null;
  errorMessage: string | null;
}

export enum CatalogueSyncStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}

export interface EndRenderBakingEvent {
  status: BakeStatus;
  version: Version;
}

export enum BakeStatus {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export interface EndCalculationEvent {
  status: CalculationResultStatus;
  version: Version;
}

export enum CalculationResultStatus {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export interface EndAutoPositioningEvent {
  status: AutoPositioningStatus;
  version: Version;
}

export enum AutoPositioningStatus {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export interface EndReportImagesEvent {
  status: ReportImagesStatus;
  version: Version;
}

export enum ReportImagesStatus {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export interface EndLampSimilarityEvent {
  status: LampSimilarityStatus;
  version: Version;
}

export enum LampSimilarityStatus {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export interface JobStartedEvent {
  version: Version;
}
